import { renderRoutes } from 'react-router-config';
import hoistStatics from 'hoist-non-react-statics';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import qs from 'querystring';

export const RouteWrapper = WrappedComponent => {
  class HoC extends Component {
    static propTypes = {
      match: PropTypes.object,
      route: PropTypes.object,
      location: PropTypes.shape({
        search: PropTypes.shape({
          replace: PropTypes.func
        })
      })
    };

    state = {
      loading: false
    };

    static contextTypes = {
      store: PropTypes.object
    };

    async componentDidMount() {
      if (WrappedComponent.needs) {
        const query = qs.parse(this.props.location.search.replace('?', '')) || {};
        this.setState({ loading: true });
        await WrappedComponent.needs(this.props.match, this.context.store.dispatch, query);
        this.setState({ loading: false });
      }
    }

    async componentWillReceiveProps(newProps) {
      if (!isEqual(newProps.match, this.props.match)) {
        if (WrappedComponent.needs) {
          window.scrollTo(0, 0);
          this.setState({ loading: true });
          await WrappedComponent.needs(newProps.match, this.context.store.dispatch);
          this.setState({ loading: false });
        }
      }
    }

    render() {
      return this.state.loading ? (
        <div
          style={{
            width: '100%',
            height: '600px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          Loading
        </div>
      ) : (
        <WrappedComponent {...this.props}>{renderRoutes(this.props.route.routes)}</WrappedComponent>
      );
    }
  }
  return hoistStatics(HoC, WrappedComponent);
};

const wrapRoutes = config => {
  return config.map(({ component, path, routes, props = {} }) => ({
    path,
    props,
    component: RouteWrapper(component),
    routes: routes ? wrapRoutes(routes) : undefined
  }));
};

export default wrapRoutes;
